/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BatchBillCreateRespVo } from './BatchBillCreateRespVo';
import {
    BatchBillCreateRespVoFromJSON,
    BatchBillCreateRespVoFromJSONTyped,
    BatchBillCreateRespVoToJSON,
    BatchBillCreateRespVoToJSONTyped,
} from './BatchBillCreateRespVo';

/**
 * 
 * @export
 * @interface ResponseBatchBillCreateRespVo
 */
export interface ResponseBatchBillCreateRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseBatchBillCreateRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseBatchBillCreateRespVo
     */
    message?: string;
    /**
     * 
     * @type {BatchBillCreateRespVo}
     * @memberof ResponseBatchBillCreateRespVo
     */
    data?: BatchBillCreateRespVo;
}

/**
 * Check if a given object implements the ResponseBatchBillCreateRespVo interface.
 */
export function instanceOfResponseBatchBillCreateRespVo(value: object): value is ResponseBatchBillCreateRespVo {
    return true;
}

export function ResponseBatchBillCreateRespVoFromJSON(json: any): ResponseBatchBillCreateRespVo {
    return ResponseBatchBillCreateRespVoFromJSONTyped(json, false);
}

export function ResponseBatchBillCreateRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseBatchBillCreateRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : BatchBillCreateRespVoFromJSON(json['data']),
    };
}

export function ResponseBatchBillCreateRespVoToJSON(json: any): ResponseBatchBillCreateRespVo {
    return ResponseBatchBillCreateRespVoToJSONTyped(json, false);
}

export function ResponseBatchBillCreateRespVoToJSONTyped(value?: ResponseBatchBillCreateRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': BatchBillCreateRespVoToJSON(value['data']),
    };
}

